import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome, ${data.name}`);
        if (data.needs_profile) navigate("/complete-profile", { replace: true });
        else navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return <div className="py-24 text-center text-muted-foreground" data-testid="auth-callback">Signing you in…</div>;
}
